// CreateTicket.js
import React, { useState } from 'react';
import '../../../../assests/css/admin/Help&Support/CreateTicket/CreateTicket.css';

const CreateTicket = ({ onBack }) => {
  const [formData, setFormData] = useState({
    subject: '',
    category: 'Technical Issue',
    priority: 'Medium',
    description: ''
  });
  const [attachments, setAttachments] = useState([]);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(file => file.size <= 5 * 1024 * 1024);
    
    if (validFiles.length !== files.length) {
      alert('Some files were too large (max 5MB)');
    }
    
    setAttachments([...attachments, ...validFiles]);
  };

  const removeFile = (index) => {
    setAttachments(attachments.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    if (!formData.subject.trim()) {
      alert('Please enter a subject');
      return;
    }
    
    if (!formData.description.trim()) {
      alert('Please enter a description');
      return;
    }

    console.log('Submitting ticket:', { ...formData, attachments });
    alert('Ticket submitted successfully!');
    onBack();
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  };

  return (
    <div className="AdminCreateTicket-container">
      <div className="AdminCreateTicket-breadcrumb">
        <span onClick={onBack} style={{cursor: 'pointer', color: '#3182ce'}}>Support</span>
        <span> › </span>
        <span>Create New Ticket</span>
      </div>
      
      <h1 className="AdminCreateTicket-title">Create Support Ticket</h1>
      <p className="AdminCreateTicket-subtitle">Fill out the details below and we'll get back to you as soon as possible.</p>

      <div className="AdminCreateTicket-layout">
        <div className="AdminCreateTicket-form">
          <div className="AdminCreateTicket-field">
            <label>Subject</label>
            <input
              type="text"
              placeholder="e.g., Issue with payment gateway integration"
              value={formData.subject}
              onChange={(e) => handleChange('subject', e.target.value)}
            />
          </div>

          <div className="AdminCreateTicket-row">
            <div className="AdminCreateTicket-field">
              <label>Category</label>
              <select 
                value={formData.category} 
                onChange={(e) => handleChange('category', e.target.value)}
              >
                <option>Technical Issue</option>
                <option>Billing Question</option>
                <option>Feature Request</option>
                <option>Account Management</option>
              </select>
            </div>

            <div className="AdminCreateTicket-field">
              <label>Priority</label>
              <div className="AdminCreateTicket-priority-group">
                {['Low', 'Medium', 'High'].map((p) => (
                  <label key={p} className="AdminCreateTicket-priority-option">
                    <input
                      type="radio"
                      name="priority"
                      value={p}
                      checked={formData.priority === p}
                      onChange={(e) => handleChange('priority', e.target.value)}
                    />
                    <span className={`AdminCreateTicket-priority-label AdminCreateTicket-priority-${p.toLowerCase()}`}>
                      {p}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="AdminCreateTicket-field">
            <label>Description</label>
            <textarea
              placeholder="Please describe your problem in detail..."
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
            />
          </div>

          <div className="AdminCreateTicket-field">
            <label>Attachments</label>
            <div className="AdminCreateTicket-upload">
              <input
                type="file"
                id="file-upload"
                multiple
                accept=".png,.jpg,.jpeg,.pdf,.txt"
                onChange={handleFileUpload}
                style={{display: 'none'}}
              />
              <label htmlFor="file-upload" className="AdminCreateTicket-upload-area">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/>
                </svg>
                <p>Click or drag files to upload</p>
                <p className="AdminCreateTicket-upload-hint">Max size: 5MB. Formats: PNG, JPG, PDF, TXT</p>
              </label>
            </div>
            {attachments.length > 0 && (
              <div className="AdminCreateTicket-files">
                {attachments.map((file, index) => (
                  <div key={index} className="AdminCreateTicket-file">
                    <span>📄 {file.name} ({formatFileSize(file.size)})</span>
                    <button onClick={() => removeFile(index)}>×</button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="AdminCreateTicket-actions">
            <button className="AdminCreateTicket-cancel" onClick={onBack}>Cancel</button>
            <button className="AdminCreateTicket-submit" onClick={handleSubmit}>Submit Ticket</button>
          </div>
        </div>

        <div className="AdminCreateTicket-sidebar">
          <div className="AdminCreateTicket-info-box">
            <h3>ℹ️ Useful Information</h3>
            <div className="AdminCreateTicket-info-item">
              <strong>Expected Response Time</strong>
              <p>Our technical team typically responds within 2-4 hours during business days.</p>
            </div>
            <div className="AdminCreateTicket-info-item">
              <strong>Search Knowledge Base</strong>
              <p>You might find a solution faster in our <a href="#">documentation</a>.</p>
            </div>
            <div className="AdminCreateTicket-info-item">
              <strong>Detailed Logs</strong>
              <p>Attaching error logs or screenshots significantly speeds up the resolution process.</p>
            </div>
          </div>

          <div className="AdminCreateTicket-topics">
            <h3>Common Topics</h3>
            <div className="AdminCreateTicket-topic" onClick={() => handleChange('subject', 'Payment gateway setup')}>
              💳 Payment gateway setup
            </div>
            <div className="AdminCreateTicket-topic" onClick={() => handleChange('subject', 'Webhook configuration')}>
              🔗 Webhook configuration
            </div>
            <div className="AdminCreateTicket-topic" onClick={() => handleChange('subject', 'API Rate limiting')}>
              ⚡ API Rate limiting
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTicket;